<template>
  <div id="app" :class="[theme]">
    <div id="nav">
      <div id="header">
        <div class="theme color1" @click="theme = 'theme-black'"></div>
        <div class="theme color2" @click="theme = 'theme-white'"></div>
        <div class="theme color3" @click="theme = 'theme-gray'"></div>
      </div>
      <ul>
        <li><button @click="selected = 'colors'">Colors</button></li>
        <!-- <li><button @click="selected = 'about'">Buttons</button></li> -->
        <li><button @click="selected = 'flex'">Flex Layout</button></li>
      </ul>

      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
    </div>
    <div id="content">
      <about v-if="selected == 'about'"/>
      <home v-if="selected == 'home'"/>
      <flex v-if="selected == 'flex'"/>
      <colors v-if="selected == 'colors'"/>
    </div>

    <!-- <router-view/> -->
  </div>
</template>
<script>
import About from './views/About';
import Home from './views/Home';
import Flex from './views/Flex';
import Colors from './views/Colors';


export default {
  components: {
    'colors': Colors,
    'about': About,
    'home': Home,
    'flex': Flex
    },
  data() {
    return {
      theme: 'theme-black',
      selected: ''
    }
  }
}
</script>


<style lang="scss">
@import "./scss/main.scss";



#header {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: nowrap;

  .theme {
    display: block;
    width: 30px;
    height: 30px;
    margin: 2px;
    cursor: pointer;
  }

  .color1 {
    background-color:  #282a36;
    border: 1px solid white;
  }

  .color2 {
    background-color:  white;
    border: 1px solid black;
  }

    .color3 {
    background-color:  gray;
    border: 1px solid black;
  }
}

.theme-black {
  background-color: #282a36;
  // border-color: aquamarine;
  color: white ;

  * {
    color: white;
  }
}

.theme-white {
    background-color: white ;
      // border-color: aquamarine;
  color: #282a36;
}

.theme-gray {
    background-color: gray ;
      // border-color: aquamarine;
  color: white;
}


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;


  display: grid;
  grid-template-areas: "nav cnt ";
  grid-template-columns: 150px 1fr ;
  grid-template-rows: 1fr;

}
.ace_editor  {
  font-size: 18px;
}

  a {
    font-weight: bold;
     color: #42b983;
    &.router-link-exact-active {
      color: #42b983;
    }
  }

#nav {
  grid-column: nav;
  border-right: #42b983 dashed 1px;
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
 
  // padding: 30px;


ul {
      list-style-type: none;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0;


    button {
      border-left: 1px solid #42b983;
      border-right: 1px solid #42b983;
      border-bottom: 1px solid #42b983;
      border-top: none;

      
      padding: 5px;
      background: transparent;
      margin: 0;
      width: 100%;
      cursor: pointer;

      &:first-child {
          border-top: 1px solid #42b983;
      }

      &:hover { 
        background-color: #42b983;
        color: white;
      }
    }
}
}

#content {
  overflow:auto;
  // height: 100%;
}

</style>
